import { useState, useEffect } from 'react';
import { getFirestore, collection, addDoc, serverTimestamp, query, where, onSnapshot } from 'firebase/firestore';
import { app } from '../../config/firebase';
import { useAuth } from '../core/useAuth';

const db = getFirestore(app);

const useSendNotification = () => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const notificationsCollection = collection(db, 'notifications');
    const q = query(notificationsCollection, where('driverId', '==', user.uid));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newNotifications = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setNotifications(newNotifications);
    });

    return () => unsubscribe();
  }, [user]);

  const sendNotification = async (title, body, driverIds, data = {}) => {
    setIsSending(true);
    setError(null);

    try {
      const notificationsCollection = collection(db, 'notifications');
      
      // Create a notification for each driver
      const promises = driverIds.map(driverId => 
        addDoc(notificationsCollection, {
          title,
          body,
          driverId,
          data,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
          status: 'pending',
          attempts: 0,
          lastAttempt: null,
          messageId: null,
          error: null,
          errorCode: null
        })
      );

      await Promise.all(promises);
      return true;
    } catch (err) {
      console.error('Error creating notifications:', err);
      setError(err.message);
      return false;
    } finally {
      setIsSending(false);
    }
  };

  return { sendNotification, isSending, error, notifications };
};

export { useSendNotification };
